import axios from "axios";
const token = JSON.parse(localStorage.getItem("TOKEN"))
const timezone = JSON.parse(localStorage.getItem("TIMEZONE"))

axios.defaults.timeout = 30000;
axios.defaults.timeoutErrorMessage='timeout'
if(token){
    axios.defaults.headers.common["x-access-token"] = token;
}
if(timezone){
    axios.defaults.headers.common["timezone"] = timezone?.timezone;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Authontication(url = `${process.env.REACT_APP_BASE_URL}/api/`) {
        return {
            deleteAccount: (data) => axios.post(url+"learner/deleteLearnerAccount",data),
            Signup: (data) => axios.post(url+"learner/signupLearner",data),
            SignupWithoutOtp: (data) => axios.post(url+"learner/signup-learner-without-otp",data),
            Sosialauth: (data) => axios.post(url+"learner/sosialauth",data),
            VerifyOtp: (otp) => axios.put(url +"learner/verifyOtp", otp),
            verifyOTPV1: (data) => axios.put(url + "learner/v1/verifyOtp", data),
            ResendOtp: (data) => axios.post(url +"learner/resendotp", data),
            resendOtpV1: (data) => axios.post(url + "learner/V1/resendotp", data),
            setPassword: (data) => axios.put(url +"learner/updatepassword",data),
            Login: (data) => axios.post(url +"learner/signInLearner",data),
            quickSignup: (data) => axios.post(url +"learner/quickSignup",data),
            getLearner: (data) => axios.post(url+"learner/getLearnerById",data),
            Forgotpassword: (data) => axios.post(url +"learner/forgotpassword",data),
            GetNotes: (data) => axios.post(url +"learner/getNotes",data),
            syncORnot: (data) => axios.post(url +"learner/syncornot",data),
            Feedback: (data) => axios.post(url +"feedback/feedback",data),
            FeedbackLearner: (data) => axios.put(url +"session/learnerfeedback",data),
            AskOtpOrPassword: (data) => axios.post(url +"learner/askLearnerForOtpOrPassword",data),
            AskOtp: (data) => axios.post(url +"learner/askLearnerForOtp",data),
            askOTPV1: (data) => axios.post(url + "learner/v1/askLearnerForOtp", data),
            NumberRegister: (data) => axios.post(url +"learner/verifyPhone",data),
            NumberVerify: (data) => axios.post(url +"learner/verifyOtpNew",data),
            PolicyAccepted: (data) => axios.post(url +"learner/policyAccepted",data),
            SetupLearner:(data) => axios.put(url+ "learner/v1/setupLearner",data ),
            Teacherlogin: (data) => axios.post(url+"teacher/signInTeacher",data),
            askteacherpassword: (data) => axios.post(url+"teacher/askTeacherForOtpOrPassword",data),
            verifyteacherOtp: (data) => axios.put(url+"teacher/verifyOtp",data),
            updatePassword: (data) => axios.put(url+"teacher/updatePassword",data),
            teacherForfotPassword: (data) => axios.post(url+"teacher/forgotpassword",data),
            currentTeacher: (data) => axios.post(url+"teacher/currentteacher",data)

        }
    }
}
